import { action } from 'mobx';
import { RoomStatus, ParticipantType } from 'components/LiveClass/utils/consts';
import connectRoom from 'components/LiveClass/requests/connectRoom';
import joinClass from 'components/LiveClass/requests/joinClass';
import endSession from 'components/LiveClass/requests/endSession';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import createClass from '../../requests/createClass';

class Actions {
  constructor(store) {
    this.store = store;
  }

  @action
  syncProps(props) {
    this.props = props;
    this.store.sync(props);
  }

  @action
  createClass = async ({ contentId, contentName, currentCardId }) => {
    this.store.room.roomStatus = RoomStatus.Connecting;

    try {
      const { userId, companyId } = this.store;
      const disableRecording =
        window.__getFeatureFlagFunc && window.__getFeatureFlagFunc('live-class-disable-recording');
      const response = await createClass({
        contentName,
        companyId,
        userId,
        contentId,
        maxParticipants: 5,
        disableRecording
      });
      const { joinId, userAccessToken, roomName, classId } = response;

      const participantType = ParticipantType.Teacher;
      this.store.participantType = participantType;

      const twilioRoom = await connectRoom(roomName, userAccessToken);

      await this.initializeRoom({
        roomName,
        userAccessToken,
        joinId,
        classId,
        currentCardId,
        userId,
        participantType,
        twilioRoom
      });

      this.store.joinLiveClass.sync({ contentId, contentName });
      this.store.joinLiveClass.showPopup();

      this.store.room.roomStatus = RoomStatus.Connected;
    } catch (e) {
      console.log('Error in createClass', e);
      this.store.room.roomStatus = RoomStatus.NotCreated;
    }
  };

  @action
  joinClass = async ({ joinId }) => {
    this.store.room.roomStatus = RoomStatus.Connecting;

    try {
      const { userId, companyId } = this.store;
      const response = await joinClass({
        joinId,
        userId,
        companyId
      });
      const { error, userAccessToken, roomName, classId, createdBy } = response;
      if (error) {
        if (error.code === 'RoomComplete') {
          SnackBarHelper.showSnackbar({
            label: 'This class is completed. Please request for new join link from teacher',
            status: 'error'
          });
        }
        window.location.href = '/#/learner';
        return;
      }

      const participantType = ParticipantType.Learner;
      this.store.participantType = participantType;

      const twilioRoom = await connectRoom(roomName, userAccessToken);

      this.initializeRoom({
        roomName,
        userAccessToken,
        joinId,
        classId,
        createdBy,
        participantType,
        twilioRoom
      });

      this.store.room.roomStatus = RoomStatus.Connected;
    } catch (e) {
      console.log('Error in joinClass', e);
      this.store.room.roomStatus = RoomStatus.NotCreated;
    }
  };

  initializeRoom = async ({
    roomName,
    roomToken,
    joinId,
    classId,
    currentCardId,
    createdBy,
    participantType,
    twilioRoom
  }) => {
    this.store.room.init({
      roomName,
      roomToken,
      joinId,
      classId,
      twilioRoom,
      createdBy
    });
    this.store.localUserMedia.initUserMedia(twilioRoom.localParticipant, twilioRoom);
    this.store.participants.initParticipants(twilioRoom.participants, twilioRoom);
    await this.store.progressSync.init({ classId, currentCardId, participantType, twilioRoom });
    await this.store.activity.init({ classId });
  };

  @action
  completeClass = async () => {
    const { room, companyId } = this.store;
    const { classId, roomStatus: previousRoomStatus } = room;
    try {
      room.roomStatus = RoomStatus.Ending;

      await endSession({ classId, companyId });

      this.leaveClass();
    } catch (e) {
      console.log('Error in completeClass', e);
      this.store.room.roomStatus = previousRoomStatus;
    }
  };

  @action
  leaveClass = () => {
    this.store.room.disconnect();
    this.store.room.roomStatus = RoomStatus.NotCreated;
    this.store.membersDrawer.hideDrawer();
  };
}

export default Actions;
